/*
  Create Your Piece — step 03 · Finish (10.04). "Metal macros, not swatches."
  One row per finish the piece actually has. A finish with nothing in stock
  stays visible, disabled, and says so (10.18) — never auto-switched.
  finish_selected fires on every switch.
*/
(function () {
  'use strict';
  var CYP = window.PersonaCYP;
  if (!CYP) return;

  var COPY = {
    gold: { desc: 'Warm. Bold. Classic.' },
    silver: { desc: 'Clean. Sharp. Understated.' }
  };
  // The spec line names the real finish of each family (product data), so a
  // bracelet is never described with the pendant's plating.
  var SPEC = {
    necklace: { gold: '18K gold finish', silver: 'Polished steel' },
    cuban: { gold: 'Gold-tone PVD finish', silver: 'Mirror-polished silver finish' },
    beaded: { gold: 'Gold-tone metal detailing', silver: 'Silver-tone metal detailing' },
    curb: { gold: 'Polished gold-tone finish', silver: 'Polished silver finish' }
  };

  CYP.use(function (cyp) {
    var panel = cyp.root.querySelector('[data-pb-step="3"]');
    var rows = panel.querySelector('[data-finish-rows]');
    var next = panel.querySelector('[data-finish-next]');
    var label = panel.querySelector('[data-finish-label]');
    var builtFor = null;
    var tick = '<svg width="11" height="9" viewBox="0 0 11 9" aria-hidden="true"><path d="M1 4.5L4 7.5L10 1.5" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

    function esc(t) { return String(t || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function sized(src, w) { return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$1' + w) : src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
    function imgOf(fe) {
      if (fe.optIndex >= 0) {
        for (var i = 0; i < fe.product.variants.length; i++) {
          var v = fe.product.variants[i];
          if (v.options[fe.optIndex] === fe.optValue && v.img) return v.img;
        }
      }
      return fe.product.img[0];
    }

    function build() {
      var s = cyp.state;
      var pc = cyp.pieceBy();
      var key = s.sport + '|' + s.piece;
      if (builtFor === key) return;
      builtFor = key;
      var legend = rows.querySelector('legend');
      rows.innerHTML = '';
      rows.appendChild(legend);
      if (!pc) return;
      pc.order.forEach(function (k) {
        var fe = pc.finishes[k];
        var avail = cyp.finishAvailable(fe);
        var other = pc.order.filter(function (o) { return o !== k; })[0];
        var src = imgOf(fe);
        var copy = COPY[k] || { desc: '' };
        var spec = (SPEC[pc.family] || {})[k] || '';
        var wrap = document.createElement('div');
        wrap.className = 'pb-frow-wrap';
        wrap.innerHTML =
          '<label class="pb-frow pb-opt' + (avail ? '' : ' is-unavailable') + '" data-finish="' + k + '">' +
            '<input class="pb-radio" type="radio" name="pb-finish" value="' + k + '"' + (avail ? '' : ' disabled') + ' aria-describedby="pb-fin-' + k + '">' +
            '<span class="pb-frow__thumb">' + (src ? '<img src="' + esc(sized(src, 500)) + '" alt="" loading="lazy" decoding="async">' : '') + '</span>' +
            '<span class="pb-frow__copy">' +
              '<span class="pb-frow__name">' + esc(fe.label) + '</span>' +
              '<span class="pb-frow__desc" id="pb-fin-' + k + '">' + esc(avail ? copy.desc : 'Currently unavailable on this piece') + '</span>' +
              (spec ? '<span class="pb-frow__spec">' + esc(spec) + '</span>' : '') +
            '</span>' +
            '<span class="pb-frow__end"><span class="pb-frow__price" data-finish-price></span><span class="pb-box" aria-hidden="true">' + tick + '</span></span>' +
          '</label>' +
          (!avail && other ? '<button type="button" class="pb-textlink pb-frow__alt" data-see="' + other + '">See it in ' + esc(pc.finishes[other].label) + '</button>' : '');
        rows.appendChild(wrap);
      });
    }

    function render() {
      var s = cyp.state;
      build();
      rows.querySelectorAll('.pb-frow').forEach(function (row) {
        var input = row.querySelector('input');
        input.checked = input.value === s.finish;
        row.classList.toggle('is-selected', input.checked);
        var q = cyp.quote(Object.assign({}, s, { finish: input.value }));
        row.querySelector('[data-finish-price]').textContent = q ? cyp.money(s.type ? q.total : q.base) : '';
      });
      var fe = s.finish ? cyp.finishEntry() : null;
      var ok = !!(fe && s.finish);
      label.textContent = ok ? 'Continue in ' + fe.label : 'Continue';
      next.setAttribute('aria-disabled', ok ? 'false' : 'true');
    }

    function select(k) {
      cyp.set({ finish: k });
      cyp.track('finish_selected', { finish: k });
    }
    function commit() {
      if (!cyp.state.finish) return;
      cyp.go('4');
    }

    panel.addEventListener('change', function (e) {
      if (e.target.name === 'pb-finish') select(e.target.value);
    });
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.name === 'pb-finish') { e.preventDefault(); commit(); }
    });
    panel.addEventListener('click', function (e) {
      var see = e.target.closest('[data-see]');
      if (see) {
        select(see.getAttribute('data-see'));
        var input = rows.querySelector('input[value="' + see.getAttribute('data-see') + '"]');
        if (input) input.focus();
      }
    });
    next.addEventListener('click', commit);

    cyp.on('state', render);
  });
})();
